import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ceping",
  "use": "icon-ceping-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 48 48\" id=\"icon-ceping\">\r\n<style type=\"text/css\">\r\n\t#icon-ceping .st0{fill:none;stroke:#FFFFFF;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;}\r\n</style>\r\n<path class=\"st0\" d=\"M25.5,36H21l-10,5v-5H4V6h40v11\" />\r\n<path class=\"st0\" d=\"M12,14h3h3\" />\r\n<path class=\"st0\" d=\"M12,20h6h6\" />\r\n<path class=\"st0\" d=\"M29,30l6,5l9-11\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol